import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './editorStyles.css';
import './teacherStyles.css';
import Home from "./pages/Home";
import About from './pages/About';
import Footer from './components/Footer';
import Index from './pages/Index';
import IndexOfTeacher from './pages/teacher/index';
import Forum from './pages/Forum';
import ForumModes_chatroom from './pages/ForumMode/ForumChatRoom.js';
import ForumModes_posts from './pages/ForumMode/ForumPosts.js';

import Dashboard from './pages/Dashboard';
import PrepareLessons from './pages/teacher/PrepareLessons'
import MyClasses from './pages/student/MyClasses';
import MyCourses from './pages/student/MyCourses';
import IdeaWall from './pages/student/IdeaWall';
import QuestionWall from './pages/student/QuestionWall';
import CrossGroupDiscussion from './pages/student/CrossGroupDiscussion';
import ClassActivitiesOfStudent from './pages/student/ClassActivities';

// 新的教師管理頁面
import TeacherMain from './pages/teacher/TeacherMain';
import TeacherHome from './pages/teacher/TeacherHome';

// 課前準備相關頁面
import PreparationHome from './pages/teacher/preparation/PreparationHome';
import PreparationLessonPackageManagement from './pages/teacher/preparation/LessonPackageManagement';
import PreparationStudentManagement from './pages/teacher/preparation/StudentManagement';
import PreparationClassManagement from './pages/teacher/preparation/ClassManagement';
import PreparationCourseDispatchManagement from './pages/teacher/preparation/CourseDispatchManagement';
import PreparationTaskManagement from './pages/teacher/preparation/TaskManagement';
import PreparationSettings from './pages/teacher/preparation/Settings';

// 課中實施相關頁面
import ImplementationHome from './pages/teacher/implementation/ImplementationHome';
import ImplementationClassApplicationQuestionWall from './pages/teacher/implementation/ClassApplication/ClassApplicationQuestionWall';
import ImplementationClassApplicationIdeaWall from './pages/teacher/implementation/ClassApplication/ClassApplicationIdeaWall';
import ImplementationClassApplicationCrossGroupDiscussion from './pages/teacher/implementation/ClassApplication/ClassApplicationCrossGroupDiscussion';
import ImplementationClassApplicationDashboard from './pages/teacher/implementation/ClassApplication/ClassApplicationDashboard';
import ImplementationClassApplicationAnalyticsDashboard from './pages/teacher/implementation/ClassApplication/ClassApplicationAnalyticsDashboard';
import StudentAnalyticsDashboard from './pages/student/StudentAnalyticsDashboard';
import ImplementationClassApplicationTaskDispatch from './pages/teacher/implementation/ClassApplication/ClassApplicationTaskDispatch';

// 課後診斷相關頁面
import DiagnosisHome from './pages/teacher/diagnosis/DiagnosisHome';
import PostClassDiagnosisCenter from './pages/teacher/implementation/PostClassDiagnosisCenter';
import PostClassDiagnosisCompare from './pages/teacher/implementation/PostClassDiagnosisCompare';

import { ModeProvider } from './contexts/ModeContext';

export default function App() {
  return (
    <ModeProvider>
      <Router 
        className="App"
        future={{
          v7_relativeSplatPath: true
        }}
      >
          <Routes>
              <Route path='/' element={[<Home/>, <About/>, <Footer/>]}></Route>
              <Route path='/about' element={<About/>}></Route>
              <Route path='/home' element={<Index/>}></Route>
              
              {/* 舊的教師頁面 */}
              <Route path='/teacher/home' element={<IndexOfTeacher/>}></Route>
              <Route path='/teacher/pageOfPrepareLesson' element={<PrepareLessons/>}></Route>
              
                             {/* 教師管理系統 - 登入後直接進入課前準備 */}
               <Route path='/teacher' element={<PreparationHome/>}></Route>
               <Route path='/teacher/preparation' element={<PreparationHome/>}></Route>
               
               {/* 課前準備相關路由 */}
               <Route path='/teacher/preparation/lesson-packages' element={<PreparationLessonPackageManagement/>}></Route>
               <Route path='/teacher/preparation/students' element={<PreparationStudentManagement/>}></Route>
               <Route path='/teacher/preparation/communities' element={<PreparationClassManagement/>}></Route>
               <Route path='/teacher/preparation/course-dispatch' element={<PreparationCourseDispatchManagement/>}></Route>
               <Route path='/teacher/preparation/task-management/:courseDispatchId' element={<PreparationTaskManagement/>}></Route>
               <Route path='/teacher/preparation/settings' element={<PreparationSettings/>}></Route>
               
               {/* 課中實施相關路由 */}
               <Route path='/teacher/implementation' element={<ImplementationHome/>}></Route>
               <Route path='/teacher/implementation/course/:courseDispatchId/dashboard-only' element={<ImplementationClassApplicationDashboard/>}></Route>
               <Route path='/teacher/implementation/community-applications/:id/analytics' element={<ImplementationClassApplicationAnalyticsDashboard/>}></Route>
               
               {/* 舊路由保留（向後相容） */}
               <Route path='/teacher/implementation/community-applications/:id/question-wall' element={<ImplementationClassApplicationQuestionWall/>}></Route>
               <Route path='/teacher/implementation/community-applications/:id/idea-wall' element={<ImplementationClassApplicationIdeaWall/>}></Route>
               <Route path='/teacher/implementation/community-applications/:id/cross-group-discussion' element={<ImplementationClassApplicationCrossGroupDiscussion/>}></Route>
               <Route path='/teacher/implementation/community-applications/:id/dashboard-only' element={<ImplementationClassApplicationDashboard/>}></Route>
               <Route path='/teacher/implementation/community-applications/:id/task-dispatch' element={<ImplementationClassApplicationTaskDispatch/>}></Route>
               
               {/* 課後診斷相關路由 */}
               <Route path='/teacher/diagnosis' element={<PostClassDiagnosisCenter/>}></Route>
               <Route path='/teacher/diagnosis/compare' element={<PostClassDiagnosisCenter/>}></Route>
               <Route path='/teacher/diagnosis/settings' element={<DiagnosisHome/>}></Route>
              
              <Route path='/forum' element={<Forum/>}></Route>
              <Route path='/dashboard' element={<Dashboard/>}></Route>
              <Route path='/forum/modes/chatroom' element={<ForumModes_chatroom/>}></Route>
              <Route path='/forum/modes/posts' element={<ForumModes_posts/>}></Route>
              <Route path='/student/my-classes' element={<MyClasses/>}></Route>
              <Route path='/student/my-courses' element={<MyCourses/>}></Route>
              {/* 向後相容舊路徑 */}
              <Route path='/student/my-tasks' element={<MyCourses/>}></Route>
              <Route path='/student/course-list' element={<MyCourses/>}></Route>
              {/* 跨組討論不需要 groupId，因為是整個課程共用 */}
              <Route path='/student/cross-group/:courseDispatchId' element={<CrossGroupDiscussion/>}></Route>
              {/* 想法牆和問題牆需要 groupId */}
              <Route path='/student/idea-wall/:courseDispatchId/:groupId' element={<IdeaWall/>}></Route>
              <Route path='/student/question-wall/:courseDispatchId/:groupId' element={<QuestionWall/>}></Route>
              <Route path='/student/analytics/:courseDispatchId/:groupId' element={<StudentAnalyticsDashboard/>}></Route>
              {/* 向後兼容：保留沒有 groupId 的路由（用於想法牆和問題牆） */}
              <Route path='/student/idea-wall/:courseDispatchId' element={<IdeaWall/>}></Route>
              <Route path='/student/question-wall/:courseDispatchId' element={<QuestionWall/>}></Route>
              <Route path='/student/class/:classId/activities' element={<ClassActivitiesOfStudent/>}></Route>
          </Routes>
      </Router>
    </ModeProvider>
  );
}